import styled from 'styled-components';
import { pretendardFont } from '../../styles/typography';

export const PageWrapper = styled.div`
  min-height: 100vh;
  background: #ffffff;
  padding: 140px 0 120px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 120px 0 80px;
  }
`;

export const PageHeader = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 48px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

export const PageHeaderText = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
`;

export const PageLabel = styled.span`
  ${pretendardFont}
  display: inline-block;
  padding: 8px 16px;
  margin-bottom: 16px;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => '#CEDA87'};
  color: ${({ theme }) => '#CEDA87'};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
`;

export const PageTitle = styled.h1`
  ${pretendardFont}
  color: #111111;
  font-size: 48px;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -1.2px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 32px;
    letter-spacing: -0.8px;
  }
`;

export const TabGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    justify-content: center;
    width: 100%;
  }
`;

export const Tab = styled.button<{ $active: boolean }>`
  ${pretendardFont}
  padding: 10px 24px;
  border-radius: 999px;
  border: 1.5px solid ${({ $active }) => ($active ? '#111111' : '#dddddd')};
  background: ${({ $active }) => ($active ? '#111111' : '#ffffff')};
  color: ${({ $active }) => ($active ? '#ffffff' : '#111111')};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
`;

export const PageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
    width: 100%;

    & > * {
      min-width: 0;
    }
  }
`;
